export default "__VITE_ASSET__0c165bf1__"